import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Button,
  Input,
  FormFeedback,
  Col,
  Row,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { deleteTicket } from "connection/backend";

const TicketDelete = (props) => {
  const redirect = () => {
    props.resetFunction();
  };

  const [ticketDetail, setTicketDetail] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    delData(props.ticket.code);
  };

  const delData = async (id) => {
    try {
      const response = await deleteTicket(id);
      if (response.status === 200) {
        props.toggleFunction();
        setTicketDetail(response.data.detail);
      }
    } catch (error) {
      console.log("Error al cancelar el ticket.");
    }
  };

  return (
    <>
      <Modal
        isOpen={props.modal}
        toggle={props.toggleFunction}
        centered={true}
        backdrop="static"
        size="ms"
      >
        <ModalHeader
          toggle={props.toggleFunction}
          className="justify-content-center"
        >
          Cancelar ticket
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={onSubmit}>
            <Row className="justify-content-md-center mb-1">
              <Col lg={10}>
                <center>
                  <p>
                    ¿Está seguro/a que quiere cancelar el ticket{" "}
                    <b>{props.ticket.consecutive}</b>?
                  </p>
                </center>
              </Col>
            </Row>

            <Row className="justify-content-md-center">
              <Col lg={4}>
                <Button color="primary" className="btn col-12" type="submit">
                  Sí
                </Button>
              </Col>
              <Col lg={4}>
                <Button
                  color="secondary"
                  className="btn col-12"
                  onClick={() => props.toggleFunction()}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
      {ticketDetail ? (
        <SweetAlert
          title="¡Hecho!"
          success
          showConfirm={true}
          onConfirm={() => {
            redirect();
          }}
        >
          El ticket {props.ticket.consecutive} se ha cancelado correctamente.
        </SweetAlert>
      ) : null}
    </>
  );
};

export default TicketDelete;
